import { PositionenItemResponse } from '@/types/service-response'
import moment from 'moment'

export class ProjectBookingPositionen {
  public constructor (
    readonly ID: number,
    readonly Selektiert: boolean,
    readonly Pos: number,
    readonly Bezeichnung: string | null,
    readonly SollMenge: string | null, //double
    readonly Verfuegbar: string | null, //double
    readonly Bestand: string | null, //double
    readonly InKommissionierung: number | null,
    readonly Gesperrte: number | null,
    readonly Reserviert: string | null, //double
    readonly Bestellt: string | null, //double
    readonly EinheitCode: string | null,
    readonly SplittErlaubt: boolean,
    readonly DatumSoll: string | null,
    readonly LetzterBeleg: string | null,
  ) {}

  static createFromResponse (responseData: PositionenItemResponse[]): Array<ProjectBookingPositionen> {
    let result: Array<ProjectBookingPositionen> = []
    if (responseData) {
      result = responseData.map((item: PositionenItemResponse) => {
        return new ProjectBookingPositionen(
          item.ID,
          item.Selektiert,
          item.Pos,
          item.Bezeichnung,
          item.SollMenge !== null ? item.SollMenge.toFixed(3) : null,
          item.Verfuegbar !== null ? item.Verfuegbar.toFixed(3) : null,
          item.Bestand !== null ? item.Bestand.toFixed(3) : null,
          item.InKommissionierung,
          item.Gesperrte,
          item.Reserviert !== null ? item.Reserviert.toFixed(3) : null,
          item.Bestellt !== null ? item.Bestellt.toFixed(3) : null,
          item.EinheitCode,
          item.SplittErlaubt,
          item.DatumSoll ? moment(item.DatumSoll).format('DD.MM.YYYY') : null,
          item.LetzterBeleg
        )
      })
    }
    return result
  }
}
